import { Card, Cell, Image, Text } from '@vinted/web-ui'

type Props = {
  url?: string
  bottomText: string
  itemsCount?: number
}

const ItemPhoto = ({ url, bottomText, itemsCount }: Props) => {
  const renderPhoto = () => (
    <Image
      src={url}
      size={Image.Size.X2Large}
      label={itemsCount ? itemsCount.toString() : ''}
      alt=""
    />
  )

  return (
    <div className="conversation-education__item-photo--rotate">
      <Card styling={Card.Styling.Elevated}>
        <div className="conversation-education__item-photo u-flexbox u-position-relative">
          {renderPhoto()}
          <div className="conversation-education__item-photo-text u-fill-width">
            <Cell theme="success" styling={Cell.Styling.Tight}>
              <div className="u-ui-padding-vertical-small">
                <Text
                  as="h3"
                  theme="inverse"
                  type={Text.Type.Subtitle}
                  text={bottomText}
                  alignment={Text.Alignment.Center}
                  width={Text.Width.Parent}
                />
              </div>
            </Cell>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ItemPhoto
